export default function Footer() {
  return (
    <footer className="relative bg-black text-white overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-zinc-900 to-black"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#d1bc8a]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#d1bc8a]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
          {/* Logo & Tagline */}
          <div className="text-center mb-20">
            <div className="flex justify-center mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/58657a40-7d20-4722-b4bf-7cb9c2b00d30.png"
                alt="Bamme Media Logo"
                className="h-32 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-xl text-gray-400">
              Digitale Exzellenz aus Wernigerode
            </p>
          </div>

          {/* Footer Grid - auf Mobile 2 Spalten */}
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-20">
            {/* Services */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-[#d1bc8a]">Services</h3>
              <ul className="space-y-4">
                <li>
                  <a href="/webdesign-entwicklung" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Webdesign & Entwicklung
                  </a>
                </li>
                <li>
                  <a href="/social-media" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Social Media Marketing
                  </a>
                </li>
                <li>
                  <a href="/foto-videographie" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Foto & Videographie
                  </a>
                </li>
              </ul>
            </div>

            {/* Unternehmen */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-[#d1bc8a]">Unternehmen</h3>
              <ul className="space-y-4">
                <li>
                  <a href="/#about" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Über uns
                  </a>
                </li>
                <li>
                  <a href="/portfolio" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Portfolio
                  </a>
                </li>
                <li>
                  <a href="/#process" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Unser Prozess
                  </a>
                </li>
                <li>
                  <a href="/#contact" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Kontakt
                  </a>
                </li>
              </ul>
            </div>

            {/* Rechtliches */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-[#d1bc8a]">Rechtliches</h3>
              <ul className="space-y-4">
                <li>
                  <a href="/impressum" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Impressum
                  </a>
                </li>
                <li>
                  <a href="/datenschutz" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    Datenschutz
                  </a>
                </li>
                <li>
                  <button 
                    onClick={() => window.dispatchEvent(new Event('openCookieSettings'))}
                    className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer text-left"
                  >
                    Cookie-Einstellungen
                  </button>
                </li>
              </ul>
            </div>

            {/* Kontakt */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-[#d1bc8a]">Kontakt</h3>
              <ul className="space-y-4">
                <li>
                  <a href="tel:017645725863" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    017645725863
                  </a>
                </li>
                <li>
                  <a href="mailto:bamme.media@gmail.com" className="text-gray-400 hover:text-[#d1bc8a] transition-colors duration-300 cursor-pointer">
                    bamme.media@gmail.com
                  </a>
                </li>
                <li className="text-gray-400">
                  38855 Wernigerode<br />
                  Deutschland
                </li>
              </ul>

              {/* Social Media - auf Mobile zentriert */}
              <div className="flex justify-start md:justify-start space-x-4 mt-8">
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 border-2 border-white/20 rounded-full flex items-center justify-center hover:border-[#d1bc8a] hover:shadow-[0_0_20px_rgba(209,188,138,0.3)] transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 border-2 border-white/20 rounded-full flex items-center justify-center hover:border-[#d1bc8a] hover:shadow-[0_0_20px_rgba(209,188,138,0.3)] transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>

              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-12"></div>

          {/* Bottom Bar */}
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm">
            <p>
              © {new Date().getFullYear()} BAMME MEDIA. Alle Rechte vorbehalten.
            </p>
            <p className="mt-4 md:mt-0">
              Made with <span className="text-[#d1bc8a]">♥</span> in Wernigerode
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}